/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { AppBar, Drawer, Container, Grid, Box, Link, IconButton, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { animateScroll as scroll } from 'react-scroll/modules'
import clsx from 'clsx'
import { HashLink, NavHashLink } from 'react-router-hash-link'
import MenuIcon from '@mui/icons-material/Menu'
import CloseIcon from '@mui/icons-material/Close'
import { StopAction } from '../../stop-action'
import { MyLink } from '../my-link'
import { img } from '../../../imgs'
import { useReduxSelector } from '../../../hooks'
import { str } from '../../../utils'

type MenuItem = {
  title: string
  key: string
  url?: string
  hash: boolean
  target: '_self' | '_blank'
}

const { REACT_APP_RULES_URL: RULES } = process.env

const menu: MenuItem[] = [
  {
    title: 'Новости',
    key: 'news',
    hash: true,
    target: '_self',
  },
  // {
  //   title: 'География кубка',
  //   key: 'maps',
  //   hash: true,
  //   target: '_self',
  // },
  {
    title: 'Турнирная таблица',
    key: 'tourtable',
    hash: true,
    target: '_self',
  },
]
export const MobileMenu: React.FC = (): JSX.Element => {
  const classes = useStyles()

  const { REACT_APP_URL: URL, REACT_APP_PORTAL_URL: PORTAL } = process.env

  const { auth } = useReduxSelector((state) => state.auth)
  const { data: constants } = useReduxSelector((state) => state.constants)

  const [open, setOpen] = useState<boolean>(false)

  const onScrollTop = () => {
    setOpen(false)
    scroll.scrollToTop()
  }

  const onScroll = () => {
    window.scrollTo(0, 0)
  }

  const handleDrawerOpen = () => {
    setOpen(true)
  }

  const handleDrawerClose = () => {
    setOpen(false)
  }

  return (
    <>
      <AppBar className={classes.app_bar} position="relative">
        {!open ? (
          <Container className={classes.container}>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={0}
              className={classes.grid}
            >
              <Grid item xs="auto">
                <Link component={MyLink} to="/" onClick={onScrollTop} className={classes.link_logo}>
                  <img src={img.logoStart} alt="..." className={classes.logo} />
                </Link>
              </Grid>
              <Grid item xs="auto">
                <IconButton
                  onClick={handleDrawerOpen}
                  className={clsx(open && classes.hide, classes.icon_button)}
                  style={{ paddingLeft: 0, paddingRight: 0 }}
                >
                  <MenuIcon style={{ fontSize: 45, color: '#292929' }} />
                </IconButton>
              </Grid>
            </Grid>
          </Container>
        ) : null}
      </AppBar>

      <Drawer className={classes.drawer} anchor="top" open={open} onClose={handleDrawerClose}>
        <Container className={classes.drawer_container}>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={0}
            className={classes.grid}
          >
            <Grid item xs="auto">
              <Link component={MyLink} to="/" onClick={onScrollTop} className={classes.link_logo}>
                <img src={img.logoStart} alt="..." className={classes.logo} />
              </Link>
            </Grid>
            <Grid item xs="auto">
              <IconButton
                onClick={handleDrawerClose}
                className={classes.icon_button}
                style={{ paddingLeft: 0, paddingRight: 0 }}
              >
                <CloseIcon style={{ fontSize: 45, color: '#292929' }} />
              </IconButton>
            </Grid>
          </Grid>
        </Container>
        <Box mt={3}>
          <Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
            <Grid item xs={12}>
              <Box className={classes.box_link}>
                <Link
                  to="/"
                  component={MyLink}
                  onClick={onScroll}
                  className={clsx(classes.drawer_item, classes.selectLink)}
                >
                  Pro кубок
                </Link>
                {/* <NavHashLink to="/#old" smooth onClick={handleDrawerClose} className={classes.drawer_item}> */}
                {/*  Как это было */}
                {/* </NavHashLink> */}
              </Box>
            </Grid>
            {auth &&
              menu.map((i, k) => {
                const { key, title } = i
                return (
                  <Grid key={k + key} item xs={12}>
                    <Box className={classes.box_link}>
                      <NavHashLink to={`/#${key}`} smooth onClick={handleDrawerClose} className={classes.drawer_item}>
                        {str.normalize(title)}
                      </NavHashLink>
                    </Box>
                  </Grid>
                )
              })}
            {auth ? (
              <>
                <Grid item xs={12}>
                  <Box className={classes.box_link}>
                    <Link
                      component={MyLink}
                      to="/media"
                      onClick={onScroll}
                      className={clsx(classes.drawer_item, classes.selectLink)}
                    >
                      Кубок в объективе
                    </Link>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box className={classes.box_link}>
                    <Link
                      component={MyLink}
                      to={window.location.href === `${URL}/lk?checklist` ? '/lk?checklist' : '/lk'}
                      onClick={onScroll}
                      className={clsx(classes.drawer_item, classes.selectLink)}
                    >
                      Личный кабинет
                    </Link>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box className={classes.box_link} mb={4}>
                    <Link component={MyLink} to="/logout" className={classes.signin}>
                      Вернуться на портал
                    </Link>
                  </Box>
                </Grid>
              </>
            ) : null}
          </Grid>
        </Box>
      </Drawer>
    </>
  )
}

const useStyles = makeStyles(({ spacing, font, breakpoints: { down }, palette }: Theme) => ({
  app_bar: {
    width: '100%',
    height: 100,
    color: 'black',
    [down('sm')]: {
      height: 80,
    },
  },
  container: {
    maxWidth: '80%',
    [down('sm')]: {
      maxWidth: '90%',
    },
  },
  drawer_container: {
    maxWidth: '95%',
    [down('sm')]: {
      maxWidth: '90%',
    },
  },
  grid: {
    height: 100,
    [down('sm')]: {
      height: 80,
    },
  },
  hide: {
    display: 'none',
  },
  logo: {
    width: 120,
    height: 'auto',
    [down('sm')]: {
      width: 100,
    },
  },
  icon_button: {
    padding: 0,
    margin: 0,
    '&:hover': {
      background: 'none',
    },
  },
  link: {
    '-webkit-tap-highlight-color': 'transparent',
    display: 'block',
    cursor: 'pointer',
    textDecoration: 'underline!important',
    textTransform: 'uppercase',
    fontSize: '16px!important',
    color: `${palette.text.primary}!important`,
    '&:hover': {
      color: palette.text.primary,
    },
  },
  link_logo: {
    '-webkit-tap-highlight-color': 'transparent',
    display: 'block',
    cursor: 'pointer',
    textDecoration: 'none!important',
  },
  signin: {
    '-webkit-tap-highlight-color': 'transparent',
    display: 'block',
    cursor: 'pointer',
    position: 'relative',
    textDecoration: 'none!important',
    textTransform: 'uppercase',
    fontSize: '14px!important',
    fontWeight: 600,
    color: '#6C6C6C!important',
    '&:hover': {
      color: palette.text.primary,
      textDecoration: 'none',
    },
  },
  drawer: {
    width: '100%',
    maxWidth: 350,
    '& .MuiPaper-root': {
      width: '100%',
      backgroundColor: `${palette.primary.dark}!important`,
      backgroundImage: 'none',
    },
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, .7)',
    },
  },
  box_link: {
    width: '100%',
    padding: '10px 0',
    display: 'flex',
    justifyContent: 'center',
  },
  drawer_item: {
    '-webkit-tap-highlight-color': 'transparent',
    display: 'block',
    cursor: 'pointer',
    position: 'relative',
    textDecoration: 'none!important',
    textTransform: 'uppercase',
    fontSize: '16px!important',
    fontWeight: 600,
    color: '#6C6C6C!important',
    '&:hover': {
      color: palette.text.primary,
      textDecoration: 'none',
    },
    // '&.active': {
    //   color: `${palette.primary.contrastText}!important`,
    //   '&:after': {
    //     position: 'absolute',
    //     width: '100%',
    //     content: "''",
    //     marginTop: 2,
    //     display: 'block',
    //     border: `1px solid ${palette.error.main}`,
    //   },
    // },
    [down('sm')]: {
      fontSize: 16,
    },
  },
  selectLink: {
    '&.active': {
      color: `${palette.primary.contrastText}!important`,
      '&:after': {
        position: 'absolute',
        width: '100%',
        content: "''",
        marginTop: 2,
        display: 'block',
        border: `1px solid ${palette.error.main}`,
      },
    },
  },
  burger: {
    width: 32,
    height: 24,
    [down('sm')]: {
      width: 29,
      height: 20,
    },
  },
  close: {
    width: 22,
    height: 22,
    [down('sm')]: {
      width: 18,
      height: 18,
    },
  },
}))
